import { Component, input, model } from '@angular/core';

import { IconModule } from '@hglobal/fin-ui';

export interface Step {
  value: number;
  completed: boolean;
}

const DEFAULT_STEP: Step = {
  value: 1,
  completed: false,
};

@Component({
  selector: 'kr-stepper',
  imports: [IconModule],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss',
})
export class StepperComponent {
  steps = input<Step[]>([]);
  activeStep = model<Step>(DEFAULT_STEP);

  selectStep(step: Step): void {
    this.activeStep.set(step);
  }
}
